
import axios from 'axios';



export function getReport(reportName, reportingToken) {
  axios.defaults.withCredentials = true;
  return axios.post(`${process.env.REACT_APP_POWERBI_URL}/api/embedding/report`, { reportName: reportName, reportToken: reportingToken });
}
export function getDashboard(reportName, reportingToken) {
  axios.defaults.withCredentials = true;
  return axios.post(`${process.env.REACT_APP_POWERBI_URL}/api/embedding/dashboard`, { dashboardName: reportName, reportToken: reportingToken });
}
export function getScoreCard(reportName, reportingToken) {
  axios.defaults.withCredentials = true;
  return axios.post(`${process.env.REACT_APP_POWERBI_URL}/api/embedding/scorecard`, { reportName: reportName, reportToken: reportingToken });
}

